import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

const CustomedBox = styled(Box)({
  marginTop: 5,
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center'
});

export default function BoxAroundTextField(props) {
  return(
    <CustomedBox>{props.children}</CustomedBox>
  )
}